import classNames from "classnames";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";
const { object, string, bool, func, number } = PropTypes;

export default class extends React.Component {
  static displayName = "AdvancedComboboxItem";

  static propTypes = {
    item: object,
    search: string,
    isSelected: bool,
    isFocused: bool,
    formatItem: func, // args: (item, isSelected, isFocused, search)
    onClick: func, // args: (item, event)
    onHover: func, // args: (item, index, event)
    index: number,
  };

  handleClick = evt => {
    return typeof this.props.onClick === "function" ? this.props.onClick(this.props.item, evt) : undefined;
  };

  handleHover = evt => {
    return typeof this.props.onHover === "function"
      ? this.props.onHover(this.props.item, this.props.index, evt)
      : undefined;
  };

  render() {
    const { item, isSelected, isFocused, search } = this.props;

    const enabled = !item.disabled;

    return (
      <li
        className={classNames(this.props.className, "et--advanced-combobox--item", {
          "is-selected": this.props.isFocused,
          "is-disabled": item.disabled,
          "is-with-icon": item.icon,
        })}
        onClick={enabled ? this.handleClick : undefined}
        onMouseEnter={enabled ? this.handleHover : undefined}
      >
        {this.props.formatItem(item, isSelected, isFocused, search)}
      </li>
    );
  }
}
